// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function ModalFooter(Props) {
  var classNameOpt = Props.className;
  var children = Props.children;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "c-modal-footer " + className
            }, children);
}

var make = ModalFooter;

export {
  make ,
  
}
/* react Not a pure module */
